import {
  Box,
  Button,
  ButtonGroup,
  Card,
  Dialog,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import PaginationTable from '../common/paginationTable';
import HeadTable from '../common/sortTable/sortTable';
import { BankedPayeeDialog } from './BankedPayeeDialog';
import { useUserPayments } from './hooks/userPayments';
import TablesSearch from '../common/tablesSearch/tablesSearch';
import FilterComponent from '../common/tablesFilter/FilterList';
import { getDate } from '../../helpers/dateHelper';
import { useUserSubscriptions } from './hooks/useSubscriptions';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import { Pause } from '@material-ui/icons';

interface Props {
  id: string;
}

export const SubscriptionsTab: FC<Props> = ({ id }) => {
  const {
    state,
    bankedDialog,
    setBankedDialog,
    handleChangeRowsPerPage,
    handleFirstPage,
    handleLastPage,
    handleChangePage,
    handleSort,
    refundPayment,
    applySearch,
    filterDropdown,
    closeFilter,
    dropdown,
    search,
    clearSearch,
    searchState,
    closeBankedDialog,
    filter,
    handleSelectStatus,
    clearSelectedStatus,
    selectedAllStatuts,
    applyStatusFilter,
    pauseSubscription,
    unpauseSubscription,
    cancelSubscription,
  } = useUserSubscriptions(id);

  return (
    <>
      <Box marginTop='0.5em'>
        <Card>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell id='active-table-head'>
                    <HeadTable
                      title='ID'
                      //  sort={handleSort}
                    />
                  </TableCell>
                  <TableCell id='active-table-head'>
                    <HeadTable
                      title='Refference'
                      // filterHandle={filterDropdown}
                    />
                    {/* {dropdown.groupid && (
                      <TablesSearch
                        search={(event) =>
                          search(event.currentTarget.value, 'groupId')
                        }
                        applySearch={() => applySearch('groupId')}
                        searchString={searchState.groupId}
                        clearSearch={() => clearSearch('groupId')}
                      />
                    )} */}
                  </TableCell>
                  {/* <TableCell id='active-table-head'>Payment Type</TableCell> */}
                  <TableCell id='active-table-head'>
                    <HeadTable
                      title='Total Cost'
                      //  sort={handleSort}
                    />
                  </TableCell>
                  <TableCell id='active-table-head'>
                    <HeadTable
                      title='Tickets'
                      //  sort={handleSort}
                    />
                  </TableCell>
                  <TableCell id='active-table-head'>
                    <HeadTable title='Used 50% FP Discount' />
                  </TableCell>
                  <TableCell id='active-table-head'>
                    <HeadTable title='Type' />
                  </TableCell>
                  <TableCell id='active-table-head'>
                    <HeadTable title='Months' />
                  </TableCell>
                  <TableCell id='active-table-head'>
                    <HeadTable
                      title='Status'
                      // sort={handleSort}
                      // filterHandle={filterDropdown}
                    />
                    {/* {dropdown.status && (
                      <FilterComponent
                        categories={filter.status}
                        selectedCategories={filter.selectedStatuts}
                        handleSelectedCategory={handleSelectStatus}
                        selectedAllCategories={selectedAllStatuts}
                        clearCategory={clearSelectedStatus}
                        hideSearch={true}
                        appointment=''
                        applyCategoryFilter={applyStatusFilter}
                      />
                    )} */}
                  </TableCell>
                  <TableCell>Purchase Date</TableCell>
                  <TableCell>Next Purchase Date</TableCell>
                  <TableCell>Ends At</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell id='active-table-head-actions'>Actions</TableCell>
                </TableRow>
              </TableHead>
              {state.subscriptions.map((item) => {
                const isDisabledPlayPauseButton =
                  state.loading ||
                  item.status === 'CANCELLED' ||
                  item.status === 'MONTHLY_CANCELLED' ||
                  item.status === 'MONTHLY_CANCELLED_FINISHED' ||
                  item.status === 'FINISHED' ||
                  item.status === 'MONTHLY_PAYMENT_ACTION_REQUIRED' ||
                  item.status === 'MONTHLY_PAYMENT_FAILED';

                const isDisabledCancelButton =
                  state.loading ||
                  item.status === 'CANCELLED' ||
                  item.status === 'MONTHLY_CANCELLED' ||
                  item.status === 'MONTHLY_CANCELLED_FINISHED' ||
                  item.status === 'FINISHED';
                return (
                  <TableBody onClick={closeFilter}>
                    <TableCell>{item._id}</TableCell>
                    <TableCell>{item.refference}</TableCell>
                    {/* <TableCell>{item.paymentWay}</TableCell> */}
                    <TableCell>{`£ ${(Math.round(item.totalCost) / 100).toFixed(
                      2
                    )}`}</TableCell>
                    <TableCell>{item.numOfTickets + item.extra}</TableCell>
                    <TableCell>
                      {item.isDiscountUsed !== undefined
                        ? item.isDiscountUsed
                          ? 'Yes'
                          : 'No'
                        : 'No'}
                    </TableCell>
                    <TableCell>
                      {item.months > 1 ? 'Prepaid' : 'Standard'}
                    </TableCell>
                    <TableCell>{item.months}</TableCell>
                    <TableCell>{item.status}</TableCell>

                    <TableCell>
                      {item.purchaseDate
                        ? getDate(new Date(item.purchaseDate))
                        : '-'}
                    </TableCell>
                    <TableCell>
                      {item.nextPurchaseDate
                        ? getDate(new Date(item.nextPurchaseDate))
                        : '-'}
                    </TableCell>
                    <TableCell>
                      {item.endsAt ? getDate(new Date(item.endsAt)) : '-'}
                    </TableCell>
                    <TableCell>{getDate(new Date(item.createdAt))}</TableCell>
                    <TableCell>
                      <ButtonGroup
                        size='small'
                        variant='contained'
                        aria-label='outlined button group'
                      >
                        <Button
                          size='small'
                          className={`table-action-button ${
                            item.status === 'ACTIVE' ? 'pause' : ''
                          }`}
                          disabled={isDisabledPlayPauseButton}
                          onClick={
                            item.status === 'ACTIVE'
                              ? pauseSubscription(item)
                              : unpauseSubscription(item)
                          }
                        >
                          {/* {item.status === 'PAUSED' ? <PlayArrowIcon /> : null} */}
                          {item.status === 'ACTIVE' ? (
                            <Pause />
                          ) : (
                            <PlayArrowIcon />
                          )}
                        </Button>
                        <Button
                          size='small'
                          className='table-action-button cancel'
                          disabled={isDisabledCancelButton}
                          onClick={cancelSubscription(item)}
                        >
                          Cancel
                        </Button>
                      </ButtonGroup>
                    </TableCell>
                  </TableBody>
                );
              })}
            </Table>
          </TableContainer>
          <PaginationTable
            page={state.page}
            perPage={state.perPage}
            collectionLength={state.subscriptions.length}
            total={state.total}
            handleChangePage={handleChangePage}
            handleLastPage={handleLastPage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleFirstPage={handleFirstPage}
            title='Subscriptions'
          />
          {bankedDialog.activePayment && (
            <Dialog open={bankedDialog.isOpen} onClose={closeBankedDialog}>
              <DialogContent>
                <BankedPayeeDialog
                  closeBankedDialog={closeBankedDialog}
                  payment={bankedDialog.activePayment}
                />
              </DialogContent>
            </Dialog>
          )}
        </Card>
      </Box>
    </>
  );
};
